export const aspectRatio = 16 / 9;
export const controlsHeight = 40;
